module.exports = __webpack_public_path__ + "img/无效.c04252c8.png";